import clsx from 'clsx';
import { COLS_FULL } from './columns';
import { HistoricAlarm } from '../api-new';

export const IssueRow = (ps: { issue: HistoricAlarm }) => {
  return (
    <tr className="group">
      {COLS_FULL.map((col, i) => (
        <td
          key={i}
          className={clsx(
            'py-5 px-3 border-b',
            col.truncate &&
              'text-ellipsis max-w-1 overflow-hidden whitespace-nowrap',
            ps.issue.al_type === 'WARNING' && 'bg-yellow-100',
            ps.issue.al_type === 'ALARM' && 'bg-red-100',
          )}>
          {col.cell ? col.cell(ps.issue) : ps.issue[col.key]}
        </td>
      ))}
    </tr>
  );
};
